<img *ngIf="!isDocument" [src]="dataUrl$" onerror="src='/assets/images/temp/default_profile.png'" />
<img *ngIf="isDocument" title="Preview" (click)="openImage($event)" [src]="dataUrl$" onerror="src='/assets/images/temp/doc.png'" />
<p-dialog class="document-show" [header]="'label_document' | translate" [(visible)]="showImage" modal="true">
    <img class="document-img" [src]="dataUrl$" onerror="src='/assets/images/temp/doc.png'" />
</p-dialog>